import { render, staticRenderFns } from "./Controller.vue?vue&type=template&id=0624eb08&"
import script from "./Controller.vue?vue&type=script&lang=js&"
export * from "./Controller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports